module.exports = __webpack_public_path__ + "static/media/Flagpole.1676a27b.svg";